import axios from '@/api/axios'

const getSportEventsComments = (params) => {
  return axios.get(`/comment${params}`)
}

const readComments = (commentIds) => {
  return axios.patch(`/read-comments`, {commentIds})
}

export default {
  getSportEventsComments,
  readComments,
}
